import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getValidateOrderProductsKey } from './order-product.keys';
import orderProductRepository from './order-product.repository';
import { UseValidateOrderProductsParams, ValidateOrderProductsOutput } from './order-product.types';

export const useValidateOrderProducts = ({
  params,
  options,
  isOfflineMode = false,
}: UseValidateOrderProductsParams) => {
  const queryFn = async () => {
    const response = await orderProductRepository(isOfflineMode).validateOrderProducts(params);
    if (!response.ok || !response.data) {
      return null;
    }
    return response.data;
  };

  return useDataQuery<ValidateOrderProductsOutput | null>(
    {
      queryKey: getValidateOrderProductsKey(params),
      queryFn,
      gcTime: 0,
    },
    options,
  );
};
